import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from "../../_models/user";
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-pickrr-manage',
  templateUrl: './pickrr-manage.component.html',
  styleUrls: ['./pickrr-manage.component.scss'],
})
export class PickrrManageComponent implements OnInit {

  carrierNameError: string;
  tokenError: string;
  pickrrData: any = {};
  carrierId: string;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.getCarrierInfoById(this.user.accountOwnerId, this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.pickrrData = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }
  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.pickrrData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  tokenBlur() {
    this.tokenError = "";
    if (!this.pickrrData.token) {
      this.tokenError = 'Please enter token';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.tokenError = "";

    if (!this.pickrrData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.pickrrData.token) {
      this.tokenError = 'Please enter token';
    }
    if (this.carrierNameError != "" || this.tokenError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {
      "connectionName": this.pickrrData.connectionName,
      "carrierCode": this.pickrrData.carrierCode,
      "organizationId": this.pickrrData.organizationId,
      "accountOwnerId": this.pickrrData.accountOwnerId,
      "token": this.pickrrData.token,
      "carrierId": this.pickrrData.carrierId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Pickrr', 'Create Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}

